// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/engine-instruments.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/engine-instruments/engine-instruments.js';

mount([g0]);
